export default __webpack_public_path__ + "static/media/Precious Plastic - Presentation - Booklet.4ea58561.pdf";